
import { Event, Payment, Expense, EventType, PaymentType, PaymentMode, ExpenseCategory, PackageType, KnowledgeItem, Lead } from './types';

// Helper to generate IDs
const uuid = () => Math.random().toString(36).substr(2, 9);

export const INITIAL_EVENTS: Event[] = [
  {
    id: 'evt_1',
    customerName: 'Rajesh Kumar',
    phone: '9876543210',
    eventType: EventType.WEDDING,
    date: '2023-11-15',
    location: 'Grand Palace Hall',
    guestCount: 500,
    packageType: PackageType.PREMIUM,
    pricePerPlate: 350,
    estimatedTotal: 175000,
    finalTotal: 175000,
    status: 'Completed'
  },
  {
    id: 'evt_2',
    customerName: 'Tech Solutions Inc',
    phone: '9988776655',
    eventType: EventType.CORPORATE,
    date: '2023-11-20',
    location: 'Tech Park Auditorium',
    guestCount: 120,
    packageType: PackageType.STANDARD,
    pricePerPlate: 250,
    estimatedTotal: 30000,
    finalTotal: 32000, // Added extras
    status: 'Completed'
  },
  {
    id: 'evt_3',
    customerName: 'Anita Desai',
    phone: '9123456780',
    eventType: EventType.HOUSE_PARTY,
    date: '2024-06-10', // Future date relative to "now"
    location: 'Sector 45 Residence',
    guestCount: 50,
    packageType: 400, // Custom
    pricePerPlate: 400,
    estimatedTotal: 20000,
    finalTotal: 20000,
    status: 'Upcoming'
  }
];

export const INITIAL_PAYMENTS: Payment[] = [
  { id: uuid(), eventId: 'evt_1', type: PaymentType.ADVANCE, amount: 50000, mode: PaymentMode.UPI, date: '2023-10-01', collectedBy: 'Owner' },
  { id: uuid(), eventId: 'evt_1', type: PaymentType.PARTIAL, amount: 50000, mode: PaymentMode.BANK_TRANSFER, date: '2023-11-01', collectedBy: 'Owner' },
  { id: uuid(), eventId: 'evt_1', type: PaymentType.BALANCE, amount: 75000, mode: PaymentMode.CASH, date: '2023-11-16', collectedBy: 'Manager' },
  
  { id: uuid(), eventId: 'evt_2', type: PaymentType.ADVANCE, amount: 10000, mode: PaymentMode.UPI, date: '2023-11-05', collectedBy: 'Owner' },
  
  { id: uuid(), eventId: 'evt_3', type: PaymentType.ADVANCE, amount: 5000, mode: PaymentMode.CASH, date: '2024-05-15', collectedBy: 'Owner' },
];

export const INITIAL_EXPENSES: Expense[] = [
  // Event 1 Expenses
  { id: uuid(), eventId: 'evt_1', category: ExpenseCategory.VEGETABLES, amount: 15000, paidBy: 'Manager', mode: PaymentMode.CASH, date: '2023-11-14' },
  { id: uuid(), eventId: 'evt_1', category: ExpenseCategory.GROCERIES, amount: 25000, paidBy: 'Owner', mode: PaymentMode.BANK_TRANSFER, date: '2023-11-10' },
  { id: uuid(), eventId: 'evt_1', category: ExpenseCategory.STAFF, amount: 20000, paidBy: 'Owner', mode: PaymentMode.CASH, date: '2023-11-15' },
  { id: uuid(), eventId: 'evt_1', category: ExpenseCategory.DAIRY, amount: 8000, paidBy: 'Manager', mode: PaymentMode.CASH, date: '2023-11-15' },
  { id: uuid(), eventId: 'evt_1', category: ExpenseCategory.GAS, amount: 5000, paidBy: 'Manager', mode: PaymentMode.UPI, date: '2023-11-13' },
  
  // Event 2 Expenses
  { id: uuid(), eventId: 'evt_2', category: ExpenseCategory.GROCERIES, amount: 8000, paidBy: 'Owner', mode: PaymentMode.UPI, date: '2023-11-19' },
  { id: uuid(), eventId: 'evt_2', category: ExpenseCategory.TRANSPORT, amount: 2000, paidBy: 'Driver', mode: PaymentMode.CASH, date: '2023-11-20' },
  
  // Global / Operational Expenses
  { id: uuid(), eventId: null, category: ExpenseCategory.MARKETING, amount: 1500, paidBy: 'Owner', mode: PaymentMode.UPI, date: '2023-11-01', description: 'Facebook Ads' },
  { id: uuid(), eventId: null, category: ExpenseCategory.UTILITIES, amount: 1200, paidBy: 'Owner', mode: PaymentMode.UPI, date: '2023-11-05', description: 'Petrol for Van' },
  { id: uuid(), eventId: null, category: ExpenseCategory.INVESTMENT, amount: 25000, paidBy: 'Owner', mode: PaymentMode.BANK_TRANSFER, date: '2023-10-15', description: 'New Large Cooking Pots' },
  { id: uuid(), eventId: null, category: ExpenseCategory.RENT, amount: 10000, paidBy: 'Owner', mode: PaymentMode.BANK_TRANSFER, date: '2023-11-01', description: 'Kitchen Rent' }
];

export const INITIAL_KNOWLEDGE: KnowledgeItem[] = [
  { 
    id: '1', 
    type: 'text', 
    name: 'Business_Rules.txt', 
    content: `CATERMAX KNOWLEDGE BASE
    
    1. PRICING:
    - Mini Catering: Starts ₹250/plate (Min 50 pax).
    - Buffet: Starts ₹350/plate (Min 50 pax).
    - Wedding Feast: Starts ₹800/plate.
    
    2. SERVICES:
    - We provide service staff, cutlery, and water.
    - Transport is extra based on distance from Ganganagar.
    
    3. CONTACT:
    - Phone/WhatsApp: 8296660073
    - Location: CBI Road, Ganganagar, Bangalore.`, 
    status: 'indexed',
    dateAdded: '2023-10-01' 
  }
];

export const INITIAL_LEADS: Lead[] = [
  {
    id: 'lead_1',
    name: 'Arjun Reddy',
    phone: '9988776655',
    source: 'Website Chat',
    status: 'HOT',
    stage: 'Negotiation',
    eventDate: new Date(new Date().setDate(new Date().getDate() + 5)).toISOString().split('T')[0], // 5 days from now
    confidenceScore: 85,
    summary: 'Looking for a premium wedding package for 500 guests. Very interested in South Indian menu.',
    aiReasoning: 'Shared phone number and budget details immediately.',
    createdAt: '2023-10-25T10:00:00Z',
    chatHistory: []
  },
  {
    id: 'lead_2',
    name: 'Sarah Jones',
    phone: '9876543210',
    source: 'Manual',
    status: 'WARM',
    stage: 'Proposal Sent',
    eventDate: new Date(new Date().setDate(new Date().getDate() + 14)).toISOString().split('T')[0], // 14 days from now
    confidenceScore: 60,
    summary: 'Inquired about birthday party catering options for 50 pax.',
    aiReasoning: 'Asked for menu but did not confirm budget.',
    createdAt: '2023-10-26T14:30:00Z',
    chatHistory: []
  },
  {
    id: 'lead_3',
    name: 'Amit Kumar',
    phone: '8888888888',
    source: 'Website Chat',
    status: 'COLD',
    stage: 'New',
    confidenceScore: 20,
    summary: 'Just browsing menu prices. No specific event.',
    aiReasoning: 'Vague responses, no specific event date.',
    createdAt: '2023-10-27T09:15:00Z',
    chatHistory: []
  },
   {
    id: 'lead_4',
    name: 'Priya Sharma',
    phone: '9191919191',
    source: 'Website Chat',
    status: 'HOT',
    stage: 'Booked',
    eventDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0], // 2 days from now
    confidenceScore: 95,
    summary: 'Confirmed booking for house warming ceremony.',
    aiReasoning: 'Explicitly stated intent to book and paid advance.',
    createdAt: '2023-10-20T11:00:00Z',
    chatHistory: []
  },
  {
    id: 'lead_5',
    name: 'Rahul Dravid',
    phone: '9900990099',
    source: 'Manual',
    status: 'WARM',
    stage: 'Contacted',
    eventDate: new Date(new Date().setDate(new Date().getDate() + 30)).toISOString().split('T')[0],
    confidenceScore: 70,
    summary: 'Corporate lunch for 200 people. Needs pure veg options.',
    aiReasoning: 'Corporate inquiry, likely high value but needs followup.',
    createdAt: '2023-10-28T16:45:00Z',
    chatHistory: []
  }
];
